(function () {
  "use strict";

  angular.module("checker.filters").filter("localeOrderBy", localeOrderBy);

  localeOrderBy.$inject = [];

  function localeOrderBy() {
    return function (array, sortPredicate, reverseOrder, underscorePosition) {
      if (!Array.isArray(array)) return array;
      if (!sortPredicate) return array;

      var isString = function (value) {
        return typeof value === "string";
      };

      var isNumber = function (value) {
        return typeof value === "number";
      };

      var isBoolean = function (value) {
        return typeof value === "boolean";
      };

      var startsWithUnderscore = function (value) {
        return isString(value) && value.charAt(0) === "_";
      };

      var arrayCopy = [];
      angular.forEach(array, function (item) {
        arrayCopy.push(item);
      });

      arrayCopy.sort(function (a, b) {
        var valueA = a[sortPredicate];
        var valueB = b[sortPredicate];

        if (isString(valueA)) {
          // Handle underscore positioning
          if (underscorePosition === "start") {
            // Put underscores at the start
            if (startsWithUnderscore(valueA) && !startsWithUnderscore(valueB)) {
              return !reverseOrder ? -1 : 1;
            }
            if (!startsWithUnderscore(valueA) && startsWithUnderscore(valueB)) {
              return !reverseOrder ? 1 : -1;
            }
          } else if (underscorePosition === "end") {
            // Put underscores at the end
            if (startsWithUnderscore(valueA) && !startsWithUnderscore(valueB)) {
              return !reverseOrder ? 1 : -1;
            }
            if (!startsWithUnderscore(valueA) && startsWithUnderscore(valueB)) {
              return !reverseOrder ? -1 : 1;
            }
          }

          // Normal string comparison for items with same underscore status
          return !reverseOrder
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }

        if (isNumber(valueA) || isBoolean(valueA))
          return !reverseOrder ? valueA - valueB : valueB - valueA;

        return 0;
      });

      return arrayCopy;
    };
  }
})();
